module.exports = __webpack_public_path__ + "img/user-scroll.5c00611c.svg";